import { render, staticRenderFns } from "./GoalDistributionSlide.vue?vue&type=template&id=96e90c2a&scoped=true&"
import script from "./GoalDistributionSlide.vue?vue&type=script&lang=js&"
export * from "./GoalDistributionSlide.vue?vue&type=script&lang=js&"
import style0 from "./GoalDistributionSlide.vue?vue&type=style&index=0&id=96e90c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e90c2a",
  null
  
)

export default component.exports